import { NgModule } from '@angular/core';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { provideHttpClient } from '@angular/common/http';
import { GridLibAngularComponentModule } from '@gen-nexus-registry/grid-lib-angular/dist/grid-lib-angular-component';
import { CommonModule } from '@angular/common';
import { SummaryCardComponent } from '../summary-card/summary-card.component';
import { DetailAccordionComponent } from '../detail-accordion/detail-accordion.component';
import { DashboardComponent } from './dashboard.component';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';

@NgModule({
  declarations: [DashboardComponent],
  imports: [DashboardRoutingModule, 
    GridLibAngularComponentModule, 
    CommonModule, 
    ReactiveFormsModule,
    TranslateModule,
    MatCardModule,
    SummaryCardComponent, 
    DetailAccordionComponent
    
  ],
  providers: [provideHttpClient()],
  exports: [DashboardComponent]
})
export class DashboardModule {}
